export function accordion() {
  /**
   * アコーディオンのアニメーション
   */
  // アコーディオンが開くときのWeb Animations APIアニメーション
  const openAnimation = (content) => {
    console.log(content.offsetHeight);
    content.animate([{ height: "0px" }, { height: `${content.offsetHeight}px` }], {
      duration: 300,
      easing: "ease-out",
    });
  };

  // アコーディオンが閉じるときのWeb Animations APIアニメーション
  const closeAnimation = (content, element) => {
    const animation = content.animate([{ height: `${content.offsetHeight}px` }, { height: 0 }], {
      duration: 300,
      easing: "ease-out",
    });

    animation.onfinish = () => {
      // アニメーションが完了したら open 属性を削除
      element.removeAttribute("open");
    };
  };

  // アコーディオンの開閉アニメーションの設定
  const accordionWebAPI = () => {
    const accordions = document.querySelectorAll(".js-accordion");
    const isOpen = "is-open";

    accordions.forEach((accordion) => {
      const summary = accordion.querySelector(".js-accordion-summary");
      const content = accordion.querySelector(".js-accordion-content");
      const icon = accordion.querySelector(".c-accordion__icon img"); // アイコン要素を取得

      summary.addEventListener("click", (event) => {
        event.preventDefault();

        if (accordion.classList.contains(isOpen)) {
          accordion.classList.remove(isOpen);

          // アイコンが存在する場合のみ処理を行う
          if (icon) {
            icon.src = "./assets/images/common/icon-qaArrow-open.png";
          }

          closeAnimation(content, accordion);
        } else {
          accordion.classList.add(isOpen);

          // アイコンが存在する場合のみ処理を行う
          if (icon) {
            icon.src = "./assets/images/common/icon-qaArrow-close.png";
          }

          accordion.setAttribute("open", "");
          openAnimation(content);
        }
      });
    });
  };

  accordionWebAPI();
}
